/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserGroupCreateDTO } from '../models/UserGroupCreateDTO';
import type { UserGroupDTO } from '../models/UserGroupDTO';
import type { UserGroupDTOODataListResponse } from '../models/UserGroupDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserGroupService {

    /**
     * @param clientId 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns UserGroupDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendv2Usergroup(
clientId?: number,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<UserGroupDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/usergroup',
            query: {
                'clientId': clientId,
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns UserGroupDTO Success
     * @throws ApiError
     */
    public static postBackendv2Usergroup(
requestBody?: UserGroupCreateDTO,
): CancelablePromise<UserGroupDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/usergroup',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns UserGroupDTO Success
     * @throws ApiError
     */
    public static getBackendv2Usergroup1(
key: number,
): CancelablePromise<UserGroupDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/usergroup/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns UserGroupDTO Success
     * @throws ApiError
     */
    public static putBackendv2Usergroup(
key: number,
requestBody?: UserGroupCreateDTO,
): CancelablePromise<UserGroupDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backendv2/usergroup/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendv2Usergroup(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backendv2/usergroup/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static internalUserGroupKey(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/UserGroup({key})',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static internalUserGroupKey1(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/UserGroup/{key}',
            path: {
                'key': key,
            },
        });
    }

}
